// extracted by mini-css-extract-plugin
module.exports = {"component":"Content-component--1Regc"};